'use client';

import React, { useEffect, useState } from 'react';
import { fetchThreads } from '@/lib/api';
import { ThreadPost } from '@/interfaces/thread-post';
import ThreadCard from './ThreadCard';

const ThreadsFeed = () => {
    const [posts, setPosts] = useState<ThreadPost[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const loadThreads = async () => {
            const fetchedPosts = await fetchThreads();
            setPosts(fetchedPosts);
            setLoading(false);
        };

        loadThreads();
    }, []);

    if (loading) return <p>Loading threads...</p>;

    return (
        <aside className="threads-feed">
            <h2 className="text-lg font-bold mb-4">최신 스레드</h2>

            <div className="flex flex-col gap-4">
                {posts.map((post) => (
                    <ThreadCard key={post.id} thread={post} />
                ))}
            </div>
        </aside>
    );
};

export default ThreadsFeed;